import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-progress-bar',
    imports: [],
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

	@Input() isVisible = true;

	@Input() value?: number;

}
